import { Col, Form, InputGroup } from "react-bootstrap";

export const FieldFormComponents = ({ label, error, children, colMd = 6 }) => (
  <Col md={colMd}>
    <div className="main-form-section mt-3">
      <Form.Group>
        <Form.Label>{label}</Form.Label>
        <InputGroup>{children}</InputGroup>
        {error && (
          <span className="text-danger" style={{ fontSize: "14px" }}>
            {error.message}
          </span>
        )}
      </Form.Group>
    </div>
  </Col>
);

export const ErrorManagement = (setError, errors) => {
  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      setError(key, {
        message: errors[key]?.msg,
      });
    }
  }
};

const Images = ["image", "logo_image", "icon", "logo"];

export const FormManagement = (data) => {
  const sendData = new FormData();

  Object.keys(data).forEach((key) => {
    const value = data[key];

    // Array
    if (Array.isArray(value)) {
      sendData.append(key, JSON.stringify(value));
    }

    // File
    else if (
      Images.includes(key) &&
      value &&
      typeof value !== "string" &&
      value.length > 0
    ) {
      sendData.append(key, value[0]);
    }

    // React Select
    else if (value && typeof value === "object" && value.value !== undefined) {
      sendData.append(key, value.value);
    }

    // Normal
    else {
      sendData.append(key, value ?? "");
    }
  });

  return sendData;
};
